import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Select } from '@ngxs/store';

import { SystemStatistics } from '../../core';

@Component({
    selector: 'gs-faq',
    templateUrl: './faq.component.html',
    standalone: false
})
export class FaqComponent implements OnInit {
  @Select(state => state.staticData.systemStatistics) systemStatistics$: Observable<SystemStatistics>;

  constructor() {
  }

  ngOnInit() {
  }
}
